import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	illustrationLabel: {
		id: 'project-create-importer-upload-flow.project-create-screen.illustration.jsw.illustration-label',
		defaultMessage:
			'Illustration showing preview of Jira project interface after the project creation is done',
		description: 'Accessible label for the illustration in create project screen',
	},
});
